<div class="row">
  <div class="col-12" style="text-align: right;">
    <button class="btn btn-success btn-md" (click)="saveEmit('create')">
      <i class="fa fa-plus" aria-hidden="true"></i> &nbsp; {{new_button}}
    </button>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <app-table
      [paginate]="paginate"
      [id] ="id"
      [dataTable]="dataTable"
      [buttons]="buttons"
      [actions]="actions"
      [print]="print"
      [show]="show"
      [delete]="delete"
      [active]="active"
      (out)="action($event)">
    </app-table>
  </div>
</div>
